module.exports = __webpack_public_path__ + "img/4club-08.2929c463.svg";